<template>
  <Teleport to="body">
  <div class="msorderwrapper">
    <!-- <head> -->
    <title>Dr Order Template</title>
    <!-- <meta charset="UTF-8" /> -->
    <!-- <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
        rel="stylesheet"
        integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
        crossorigin="anonymous"
      />
      <script
        src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js"
        integrity="sha384-MrcW6ZMFYlzcLA8Nl+NtUVF0sA7MsXsP1UyJoMp4YLEuNSfAP+JcXn/tWtIaxVXM"
        crossorigin="anonymous"
      ></script>
      <link
        href="http://13.82.95.128/keyon/bstrapGrid/css/style.css"
        type="text/css"
        rel="stylesheet"
      />
      <script
        src="https://code.jquery.com/jquery-3.6.1.min.js"
        integrity="sha256-o88AwQnZB+VDvE9tvIXrMQaPlFFSUTR+nldQm1LuPXQ="
        crossorigin="anonymous"
      ></script>
      <script
        src="https://cdn.tiny.cloud/1/no-api-key/tinymce/6/tinymce.min.js"
        referrerpolicy="origin"
      ></script>
      <script
        src="http://13.82.95.128/keyon/bstrapGrid/js/tinyplugin.js"
        type="text/javascript"
      ></script> -->
    <!-- </head> -->
    <!-- <body> -->
    <div class="order-wrapper col-sm-12 col-lg-12">
      <div class="container">
        <div class="col-sm-12 col-lg-12 opclosesec">
          <span id="closeOrdermod"
            >Order # {{ localOrder.order_display_number || localOrder.ordernumber }} For:
            <b
              >{{ `${patient.first_name} ${patient.lastname}` }} ({{
                patient.date_of_birth
              }})</b
            ></span
          >
          <span style="margin-left: 15px">
            Status:<b
              style="color: #ff0000; margin-left: 10px; padding: 5px; font-weight: 900"
              >{{ localOrder.status }}</b
            ></span
          >

          <h4></h4>
        </div>
        <!--Add Patiets Form-->
        <div class="providerformsec col-sm-12 col-md-12 col-lg-12">
          <form id="providform">
            <p id="npidlbl">NPID<span id="npispan"></span></p>
            <h3>Add Provider Form</h3>
            <div class="provformrow">
              <div class="fnamesec col-sm-12 col-md-4 col-lg-4">
                <input type="text" id="fnamefield" placeholder="* First Name" value="" />
              </div>
              <div class="lnamesec col-sm-12 col-md-4 col-lg-4">
                <input type="text" id="lnamefield" placeholder="* Last Name" value="" />
              </div>
            </div>
            <div class="provformrow">
              <div class="addronesec col-sm-12 col-md-4 col-lg-4">
                <input type="text" id="addr1field" placeholder="* Address" value="" />
              </div>
              <div class="addrtwosec col-sm-12 col-md-4 col-lg-4">
                <input type="text" id="addr2field" placeholder="* Address 2" value="" />
              </div>
            </div>
            <div class="provformrow">
              <div class="citysec col-sm-12 col-md-4 col-lg-4">
                <input type="text" id="cityfield" placeholder="* City" value="" />
              </div>
              <div class="statesec col-sm-12 col-md-4 col-lg-4">
                <input type="text" id="statefield" placeholder="* State" value="" />
              </div>
            </div>
            <div class="provformrow" style="padding: 0px 85px">
              <div class="zipsec col-sm-12 col-md-4 col-lg-4">
                <input type="text" id="zipfield" placeholder="* Zip" value="" />
              </div>
              <div class="telsec col-sm-12 col-md-4 col-lg-4">
                <input type="text" id="telfield" placeholder="* Tel" value="" />
              </div>
              <div class="faxsec col-sm-12 col-md-4 col-lg-4">
                <input type="text" id="faxfield" placeholder="* Fax" value="" />
              </div>
            </div>
            <div class="provformrow">
              <div class="savebnt col-sm-12 col-md-2 col-lg-2">
                <input type="button" id="savebtnel" value="Save and Continue" />
              </div>
              <div class="closebnt col-sm-12 col-md-2 col-lg-2">
                <input type="button" id="closebtnel" value="Close" />
              </div>
            </div>
          </form>
        </div>
        <!--end Paitent Form-->
        <form :id="'orderform' + patient.pid" @submit.prevent="saveOrder()">
          <div class="firstrow col-sm-12">
            <div class="col-sm-12 col-md-2 col-lg-2">
              <label for="orderdate" role="text">* Order Date</label>
              <input
                :disabled="ordstatus"
                :class="{ 'disabled-input': ordstatus }"
                type="date"
                required
                id="orderdate"
                :value="localOrder.orderdate"
                class="datefield"
                name="date"
              />
            </div>
            <div class="col-sm-12 col-md-2 col-lg-2">
              <label for="orderdate" role="text">* Order Time</label><br />
              <input
                :disabled="ordstatus"
                :class="{ 'disabled-input': ordstatus }"
                type="time"
                required
                id="ordertime"
                :value="localOrder.ordertime"
                class="timefield"
                name="time"
              />
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3">
              <label for="ordertype" role="text">* Order Type</label><br />
              <select
                :disabled="ordstatus"
                :class="{ 'disabled-input': ordstatus }"
                required
                id="ordertype"
                class="ordertype"
                name="ordertype"
              >
                <option selected="select" :value="localOrder.ordertype">
                  {{ localOrder.ordertype }}
                </option>
                <option value="Physicians Order">Physicians Order</option>
                <option value="Nurses Order">Nurses Order</option>
                <option value="Verbal Order">Verbal Order</option>
              </select>
            </div>
            <div class="col-sm-12 col-md-2 col-lg-2">
              <label for="abndelivered" role="text"> ABN Delivered?</label>
              <select
                :disabled="ordstatus"
                :class="{ 'disabled-input': ordstatus }"
                required
                id="abntopatient"
                class="abntopatient"
                name="abn"
              >
                <option selected value="0">N/A</option>
                <option value="1">Don't Know</option>
                <option value="2">Let's Try</option>
              </select>
            </div>
            <div class="col-sm-12 col-md-2 col-lg-2">
              <label for="phyAgentphy" role="text"> Order Read Back To Physican</label>
              <select
                :disabled="ordstatus"
                :class="{ 'disabled-input': ordstatus }"
                required
                name="phyAgent"
                id="phyAgentphy"
                class="phyAgentphy"
              >
                <option selected value="NA">N/A</option>
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12 secondrow">
            <div class="col-sm-12 col-md-4 col-lg-4">
              <label for="primphysician" role="text">* Primary Physican</label><br />
              <input
                :disabled="ordstatus"
                :class="{ 'disabled-input': ordstatus }"
                name="primphysician"
                type="text"
                required
                placeholder=""
                id="primphysician"
                style="z-index: 9000; position: relative"
                class="primphyfield"
                v-model="localOrder.primary_physician"
                @keyup.prevent="showResults"
              />
              <!-- <div v-if="searchedNpis" id="npinamesearch" class="npinamemodal">
                <div v-for="(npi, index) in searchedNpis" class="additionalnameli" :key="index + 'npi' + npi.npinumber"
                  @click="selectNpi(npi)">
                  {{ npi.name }}
                </div>
              </div>
              <template v-if="npiSearch === ''">
                <div class="npinamemodal">Linked Providers</div>
                <div id="npinamesearch" class="npinamemodal">
                  <div
                    v-for="(prov, index) in savedProviders"
                    class="additionalnameli"
                    :key="index + 'npi' + prov.npinumber"
                    @click="selectProv(prov)"
                  >
                    {{ prov.firstname + " " + prov.lastname }}
                  </div>
                </div>
              </template>
              <div class="addimgprovider">
                <img src="https://cdn0.iconfinder.com/data/icons/users-android-l-lollipop-icon-pack/24/add_user-512.png"
                  alt="Add Provider Image" title="Add Provider" width="40" height="40" />
              </div> -->
            </div>
            <!-- <div class="col-sm-12 col-md-4 col-lg-4">
              <label for="secphysician" role="text"> Secondary Physicians</label><br />
              <input :disabled="ordstatus" :class="{ 'disabled-input': ordstatus }" name="secphysician" type="text" id="secphysician" class="secphysician" v-model="patient.sec_physician" @input="updateSecPhys($event.currentTarget.value)" />
            </div> -->
            <div class="col-sm-12 col-md-4 col-lg-4">
              <label for="email" role="text">E-mail</label><br />
              <input
                :disabled="ordstatus"
                :class="{ 'disabled-input': ordstatus }"
                v-if="patient == ''"
                name="email"
                type="text"
                id="email"
                class="email"
                v-model="npiEmail"
              />
              <input
                :disabled="ordstatus"
                :class="{ 'disabled-input': ordstatus }"
                v-if="patient != ''"
                name="email"
                type="text"
                id="email"
                class="email"
                v-model="localOrder.email"
                @input="updateEmail($event.currentTarget.value)"
              />
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12 thirdrow">
            <div class="col-sm-12 col-md-4 col-lg-3">
              <label for="npinumber" role="text">* NPI Number</label><br />
              <input
                :disabled="ordstatus"
                :class="{ 'disabled-input': ordstatus }"
                name="npinumber"
                type="text"
                required
                id="npinumber"
                class="npifield"
                v-model="localOrder.npi"
                @input="updateNpi($event.currentTarget.value)"
              />
            </div>
            <div class="col-sm-12 col-md-4 col-lg-3">
              <label for="physaddress" role="text">* Address</label><br />
              <input
                :disabled="ordstatus"
                :class="{ 'disabled-input': ordstatus }"
                name="address"
                type="text"
                required
                id="physaddress"
                class="physaddressclass"
                v-model="localOrder.address"
                @input="updateAddress($event.currentTarget.value)"
              />
              <div
                v-if="searchedAddresses"
                id="npiadditionaladdr"
                class="npiadditionaladdr"
              >
                <div
                  v-for="(addr, index) in searchedAddresses"
                  @click="selectAddr(addr)"
                  class="additonaladdrli"
                  :key="index"
                >
                  {{ addr.address }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-4 col-lg-3">
              <label for="orderphonenumber" role="text">Order Phone Number</label><br />
              <input
                :disabled="ordstatus"
                :class="{ 'disabled-input': ordstatus }"
                v-if="patient != ''"
                type="tel"
                id="orderphonenumber"
                class="orderphoneclass"
                :value="order.phone"
              />
              <input
                :disabled="ordstatus"
                :class="{ 'disabled-input': ordstatus }"
                v-else
                name="orderphone"
                type="tel"
                id="orderphonenumber"
                class="orderphoneclass"
                v-model="npiPhone"
              />
            </div>
            <div class="col-sm-12 col-md-4 col-lg-3">
              <label for="orderfaxnumber" role="text">Order Fax Number</label><br />
              <input
                :disabled="ordstatus"
                :class="{ 'disabled-input': ordstatus }"
                v-if="patient == ''"
                name="orderfax"
                type="tel"
                id="orderfaxnumber"
                class="orderfaxclass"
                v-model="npiFax"
              />
              <input
                :disabled="ordstatus"
                :class="{ 'disabled-input': ordstatus }"
                v-if="patient != ''"
                name="orderfax"
                type="tel"
                id="orderfaxnumber"
                class="orderfaxclass"
                v-model="localOrder.fax"
                @input="updateFax($event.currentTarget.value)"
              />
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12 forthfrow">
            <div class="col-sm-12 col-md-6 col-lg-6 orderaction">
              <label>
                <input
                  :disabled="ordstatus"
                  :class="{ 'disabled-input': ordstatus }"
                  v-if="this.patient == ''"
                  type="checkbox"
                  id="sendtophysician"
                  name="sendtophysician"
                  value="Send To Physician"
                  v-model="sendtophys"
                />
                <input
                  :disabled="ordstatus"
                  :class="{ 'disabled-input': ordstatus }"
                  v-if="this.patient.sendtophys == '1'"
                  type="checkbox"
                  id="sendtophysician"
                  name="sendtophysician"
                  :checked="true"
                  value="Send To Physician"
                  v-model="sendtophys"
                />
                Send To Physicians
              </label>
              <label>
                <input
                  :disabled="ordstatus"
                  :class="{ 'disabled-input': ordstatus }"
                  type="checkbox"
                  name="woundcareorder"
                  id="woundcare"
                  value="Wound Care Order"
                  v-model="woundcare"
                />Wound Care Order</label
              ><br />
              <!-- <label>
                <input type="checkbox" id="verbalorder" name="verbalorder" value="Verbal Order"
                  v-model="verbalorder" />Verbal Order</label>
              <input type="date" name="verbaldate" class="verbdatefield" />
              <input type="time" name="verbaltime" class="verbtimefield" /> -->
              <!--<div class="showverober col-sm-12 col-md-12 col-lg-12">
                                <input type="date" name="verbaldate" class="verbdatefield"/>
                                <input type="time" name="timefield" class="timefield"/>
                            </div>-->
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="preloader" id="preloader" style="display: none">
              <div class="container">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  style="margin: auto; display: block"
                  width="200px"
                  height="200px"
                  viewBox="0 0 100 100"
                  preserveAspectRatio="xMidYMid"
                >
                  <g transform="translate(16.666666666666668 50)">
                    <circle cx="0" cy="0" r="6" fill="#85a2b6">
                      <animateTransform
                        attributeName="transform"
                        type="scale"
                        begin="-0.4s"
                        calcMode="spline"
                        keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                        values="0;1;0"
                        keyTimes="0;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                      ></animateTransform>
                    </circle>
                  </g>
                  <g transform="translate(33.333333333333336 50)">
                    <circle cx="0" cy="0" r="6" fill="#bbcedd">
                      <animateTransform
                        attributeName="transform"
                        type="scale"
                        begin="-0.3s"
                        calcMode="spline"
                        keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                        values="0;1;0"
                        keyTimes="0;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                      ></animateTransform>
                    </circle>
                  </g>
                  <g transform="translate(50 50)">
                    <circle cx="0" cy="0" r="6" fill="#dce4eb">
                      <animateTransform
                        attributeName="transform"
                        type="scale"
                        begin="-0.2s"
                        calcMode="spline"
                        keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                        values="0;1;0"
                        keyTimes="0;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                      ></animateTransform>
                    </circle>
                  </g>
                  <g transform="translate(66.66666666666667 50)">
                    <circle cx="0" cy="0" r="6" fill="#fdfdfd">
                      <animateTransform
                        attributeName="transform"
                        type="scale"
                        begin="-0.1s"
                        calcMode="spline"
                        keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                        values="0;1;0"
                        keyTimes="0;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                      ></animateTransform>
                    </circle>
                  </g>
                  <g transform="translate(83.33333333333333 50)">
                    <circle cx="0" cy="0" r="6" fill="#85a2b6">
                      <animateTransform
                        attributeName="transform"
                        type="scale"
                        begin="0s"
                        calcMode="spline"
                        keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                        values="0;1;0"
                        keyTimes="0;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                      ></animateTransform>
                    </circle>
                  </g>
                </svg>
              </div>
            </div>
            <div class="tabs col-sm-12 col-md-12 col-lg-12">
              <div
                v-if="localOrder && localOrder.procOrMed !== 'procedure'"
                class="medicationtab"
                :class="activeTab == 1 ? 'active' : ''"
                :style="{ display: 'block' }"
              >
                <a
                  href="#medtab"
                  id="medicationbtn"
                  title="Medications Tab"
                  @click.prevent="activeTab = 1"
                  >Medications</a
                >
              </div>
              <!-- <div class="diagnosistab" :class="activeTab == 2 ? 'active' : ''" :style="{ 'display': 'block' }">
                <a href="#diagnosistab" id="diagnosisbtn" title="Diagnosis Tab" @click.prevent="activeTab = 2">Diagnosis</a>
              </div> -->
              <div
                v-if="localOrder && localOrder.procOrMed !== 'medication'"
                class="proctab"
                :class="activeTab == 3 ? 'active' : ''"
                :style="{ display: 'block' }"
              >
                <a
                  href="#proctab"
                  id="procbtn"
                  title="Procedure Tab"
                  @click.prevent="activeTab = 3"
                  >Procedure</a
                >
              </div>
              <div class="ordescriptab" :class="activeTab == 0 ? 'active' : ''">
                <a
                  href="#orderscript"
                  id="ordescripbtn"
                  title="Order Description"
                  @click.prevent="activeTab = 0"
                  >Order Description</a
                >
              </div>
            </div>
            <!--<label for="ordertextarea" class="orderlbl">Order Descripton</label><br/>-->
            <div
              id="ordercanvas"
              :style="[activeTab == 0 ? { display: 'block' } : { display: 'none' }]"
            >
              <!-- <editor v-model="message" api-key="wtyerkxnsy7pxhf40g1mq9tjlifsy2ygztyau951df686zv9" :init="{
                plugins: [
                  'advlist',
                  'autolink',
                  'lists',
                  'link',
                  'image',
                  'charmap',
                  'preview',
                  'anchor',
                  'searchreplace',
                  'visualblocks',
                  'fullscreen',
                  'insertdatetime',
                  'media',
                  'table',
                  'help',
                  'wordcount',
                ],
                toolbar:
                  'undo redo | casechange blocks | bold italic backcolor | ' +
                  'alignleft aligncenter alignright alignjustify | ' +
                  'bullist numlist checklist outdent indent | removeformat | code table help',
              }" /> -->
              <EditorComponent
                v-model="localOrder.description"
                editorStyle="height:300px"
              >
                <template #toolbar>
                  <span class="ql-formats">
                    <button class="ql-bold"></button>
                    <button class="ql-italic"></button>
                    <button class="ql-underline"></button>
                  </span>
                </template>
              </EditorComponent>
              <br />
              <!--<div class="col-sm-12 col-md-12 col-lg-12 ordclosebtn">
                                <input type="button" value="Cancel" id="cancelbtn" class="cancelbtn"/>
                                <input type="button" value="Save & Close" id="ordersavebtn" class="orderbtn"/>
                            </div>-->
            </div>
            <div
              id="medicationcanvas"
              :style="[activeTab == 1 ? { display: 'block' } : { display: 'none' }]"
            >
              <!-- <div class="medbtn_nav">
                <a
                  href="#Edittransaction"
                  class="transbuttons"
                  title="Edit Transaction"
                  id="edittransbtn"
                  >Edit Transaction</a
                >
                <a
                  href="#Deletetransaction"
                  class="transbuttons"
                  title="Delete Transaction"
                  id="delettransbtn"
                  >Delete Transaction</a
                >
                <a
                  href="#Viewmedications"
                  class="transbuttons"
                  title="Veiw Medications"
                  id="viewcurrentmedsbtn"
                  >View Current Medications</a
                >
              </div> -->
              <div class="divider"></div>
              <div
                class="mediationmodal col-sm-12 col-md-12 col-lg-12"
                :id="'mediationmodal' + patient.id"
              >
                <div class="modaltop">
                  <section class="patienttopinfosec col-sm-12 col-md-6 col-lg-6">
                    <div id="patientname">
                      <p id="pname">
                        {{ patient.firstName + " " + patient.lastName }}
                      </p>
                    </div>
                    <div class="allergysec">
                      <span class="allergytext"
                        >Allergies: <span>{{ manualAllergies.toString() }}</span> </span
                      ><br />
                      <p></p>
                    </div>
                  </section>
                  <section class="patientsecondinfosec col-sm-12 col-md-6 col-lg-6">
                    <div id="patientbday">
                      <p id="pday">{{ patient.dob }}</p>
                    </div>
                    <div class="attendphysician">
                      <!-- <span>Attending Physician</span><br /> -->
                      <!-- <p>Dr. Joseph Mulvehill</p> -->
                    </div>
                  </section>
                </div>
                <form :id="'dosesform' + patient.pid" @submit.prevent="saveMed">
                  <div class="mednamesec col-sm-12 col-lg-12">
                    <input
                      required
                      name="medsearchbox"
                      class="medsearchbox"
                      type="search"
                      :id="'medsearchbox' + patient.pid"
                      placeholder="Search for Medications"
                      v-model="medicationSearchDescrip"
                      @keyup.prevent="showMedSearch"
                    />
                    <div
                      v-if="searchedMeds"
                      :class="'searchresult' + patient.pid"
                      id="medsearchresult"
                    >
                      <div
                        v-for="med in searchedMeds"
                        class="medlist"
                        :key="med.rxcui"
                        @click="clickMed(med)"
                      >
                        <span id="rxcui">{{ med.rxcui }}</span>
                        <p>{{ med.name }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="modalbottom">
                    <!-- <form :id="'dosesform'+patient.id" @submit.prevent="saveMed"> -->
                    <!-- <form :id="'medsearchform'+patient.id">
                    <input
                      type="search"
                      :id="'medsearchbox'+patient.id"
                      placeholder="Search for Medications"
                      v-model="medicationSearchDescrip"
                      @keyup.prevent="showMedSearch"
                    />
                    <div v-if="searchedMeds" :class="'searchresult'+patient.id" id="medsearchresult">
                      <div v-for="med in searchedMeds" class="medlist" :key="med.rxcui" @click="clickMed(med)">
                        <span id="rxcui">{{med.rxcui}}</span>
                        <p>{{med.name}}</p>
                      </div>
                    </div>
                    <div class="srchbtncontainer">
                      <input type="button" value="Cancel" :id="'cancelbtn'+patient.id" @click="closeFirstMed"/>
                    </div>
                  </form> -->
                    <div class="medfirstSec col-sm-12 col-md-4 col-lg-4">
                      <!-- <div class="flex-row">
                        <input
                          name="dosage"
                          type="text"
                          placeholder="Ex 2.5 or 1-2.5"
                          id="doseamount"
                        />
                        <select id="doesUOM" name="UOM" required>
                          <option selected="selected" value="Dose UOM"
                            >DOSE UOM *</option
                          >
                          <option value="mg">mg</option>
                          <option value="tablet">tablet</option>
                          <option value="per instruction"
                            >per instruction</option
                          >
                        </select>
                      </div> -->
                      <div class="flex-row">
                        <select id="freqselect" name="freq" required>
                          <option selected="selected" value="Frequency">
                            Frequency *
                          </option>
                          <option
                            v-for="time in mT"
                            :key="time + patient.id"
                            :value="time"
                          >
                            {{ time }}
                          </option>
                        </select>
                        <label class="prn-label"
                          >PRN<input
                            name="PRN"
                            type="checkbox"
                            :id="'prncheckbox' + patient.id"
                            value="PRN"
                          />
                        </label>
                      </div>
                      <div class="flex-row">
                        <input
                          type="text"
                          placeholder="Amount"
                          name="amount"
                          id="amount"
                        />
                      </div>
                      <div class="flex-row">
                        <select id="medRoute" name="route" required>
                          <option selected="selected" value="Route">Route *</option>
                          <option value="By mouth">By mouth</option>
                          <option value="By mouth under tongue">
                            By mouth under tongue
                          </option>
                          <option value="Cheek of mouth">Cheek of mouth</option>
                          <option value="Each ear">Each ear</option>
                          <option value="Each eye">Each eye</option>
                          <option value="Inhalation">Inhalation</option>
                        </select>
                      </div>
                      <div class="flex-row">
                        <input
                          required
                          type="text"
                          placeholder="Reason *"
                          name="reason"
                          id="medReason"
                          v-model="diagSearchDescrip"
                          @keyup.prevent="showDiagSearch"
                        />
                        <div
                          v-if="searchedDiags && searchedDiags.length != 0"
                          class="medDiagSearch"
                        >
                          <div
                            v-for="diag in searchedDiags"
                            class="medIcdli"
                            :key="diag.code"
                            @click="clickDiag(diag)"
                          >
                            <span id="icdcode">{{ diag.code }}</span> -
                            <span id="icddesript">{{ diag.description }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="flex-row">
                        <input
                          type="text"
                          placeholder="Instruction"
                          name="instructions"
                          id="medInstructions"
                        />
                      </div>
                    </div>
                    <div class="medsecondSec col-sm-12 col-md-4 col-lg-4">
                      <div class="flex-row medLabelGroup">
                        <label class="medDateLabel">Start Date</label
                        ><label class="medDateLabel">End Date</label>
                      </div>
                      <div class="flex-row">
                        <input type="date" id="medStartdate" name="startDate" />
                        <input type="date" id="Medenddate" name="endDate" />
                      </div>
                      <div class="flex-row">
                        <select id="neworchange" name="neworchange">
                          <option selected="selected" value="Dose UOM">New/Change</option>
                          <option value="New">New</option>
                          <option value="Change">Change</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      <div class="flex-column">
                        <input
                          type="text"
                          id="drugcategory"
                          name="drug"
                          placeholder="Drug Classification"
                        />
                      </div>
                    </div>
                    <div class="medthirdSec col-sm-12 col-md-4 col-lg-4">
                      <div class="flex-column medThirdCol">
                        <label>Medication Understanding</label>
                        <label
                          ><input
                            name="understanding"
                            type="radio"
                            id="meddirectionuse"
                          />Direction for Use</label
                        >
                        <label
                          ><input
                            name="understanding"
                            type="radio"
                            id="Medpurpose"
                          />Purpose</label
                        >
                        <label
                          ><input
                            type="radio"
                            id="MedSideffects"
                            name="understanding"
                          />Side Effects/Interactions</label
                        >
                        <label
                          ><input
                            name="understanding"
                            type="radio"
                            id="noUnder"
                          />None</label
                        >
                      </div>
                      <div class="flex-column medThirdCol">
                        <label>Additional Settings</label>
                        <label
                          ><input type="radio" id="agencyadmin" name="settings" />Agency
                          Administered</label
                        >
                        <label
                          ><input type="radio" id="highrisk" name="settings" />High
                          Risk</label
                        >
                        <label
                          ><input
                            type="radio"
                            id="noSettings"
                            name="settings"
                          />None</label
                        >
                      </div>
                      <div class="flex-column medThirdBtn">
                        <input type="submit" id="savemedbtn" value="Save" />
                        <input
                          type="button"
                          id="cancelmedbtn"
                          @click="closeMed"
                          value="Cancel"
                        />
                      </div>
                    </div>
                  </div>
                </form>
                <!--Start Cuerrent Med Grid-->
                <div class="order-grid col-sm-12 col-md-12 col-lg-12">
                  <div class="sortgrid">
                    <label id="switchlbl">View Current Medications</label
                    ><label id="switch"
                      ><input type="checkbox" id="toggleSearch" />
                      <span class="slider round"></span
                    ></label>
                  </div>
                  <!--end Column top-->
                  <!--end Column Row-->
                </div>
                <!--End Med Grid-->
              </div>
              <div class="order-grid col-sm-12 col-md-12 col-lg-12">
                <div class="columntop">
                  <!--Start Colum-->
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-6 top-col">
                    <span id="col2" class="coltext">Medication</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col3" class="coltext">Diagnosis</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col4" class="coltext">Frequency</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col4" class="coltext">Start</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col6" class="coltext">End</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col7" class="coltext">Route</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col8" class="coltext">Alternative Route</span>
                  </div>
                </div>
                <!--end Column top-->
                <template v-if="currentDetails && (currentDetails.medName || currentDetails.medname)">
                  <div
                    :key="'med' + (currentDetails.medId || currentDetails.medentryid || '')"
                    class="columnrow"
                  >
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-6 top-row">
                      <span id="row" class="coltext">{{ currentDetails.medName || currentDetails.medname }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ currentDetails.diagDescription }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ currentDetails.frequency }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ currentDetails.startDate }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ currentDetails.endDate }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ currentDetails.route }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ currentDetails.altRoute }}</span>
                    </div>
                  </div>
                </template>
                <!--end Column Row-->
              </div>
            </div>
            <!-- Procedure Canvas -->
            <div
              id="diagnosiscanvas"
              :style="[activeTab == 3 ? { display: 'block' } : { display: 'none' }]"
            >
              <div class="divider"></div>
              <!--<form :id="'procmodal' + patient.pid" @submit.prevent="saveProc"
                class="diagnosismodal col-sm-12 col-md-12 col-lg-12">
                <!~~ <section class="modalclose">
                  <a href="#close" title="close Modal" id="amodalclose">X</a>
                </section> ~~>
                <div class="modaltop">
                  <section class="diagtitlesec col-sm-12 col-md-6 col-lg-6">
                    <h3>Procedure</h3>
                  </section>
                </div>
                <div class="modalbottom">
                  <!~~ <div id="diagnostypeSec">
                    <label>Type:</label> <br />
                    <label>
                      <input type="checkbox" id="diagchkbox" />Diagnosis</label
                    ><br />
                    <label
                      ><input
                        type="checkbox"
                        id="procedurechkbox"
                      />Proceedure</label
                    >
                  </div> ~~>
                  <div class="icd10second col-sm-12 col-lg-12">
                    <div id="icdfirstopt" class="col-sm-12 col-md-4 col-lg-3">
                      <label>Procedure Description</label>
                      <!~~ <label id="srchbylbl">{{icdSearch ? "Search By ICD-10 Description" : "Search By ICD-10 Code"}}</label
                      ><label id="switch"
                        ><input type="checkbox" id="toggleSearch" v-model="icdSearch"/></label> ~~>
                      <br />
                      <input required name="procCode" type="text" id="srchnlookupterms" title="cpt proc field"
                        v-model="procSearchDescrip" placeholder='Type in your CPT description'
                        @keyup.prevent="showProcSearch" />
                      <!~~ <div v-if="searchedProcs && searchedProcs.length != 0" class="icd10listcontainer col-lg-12">
                        <div v-for="proc in searchedProcs" class="icd10srchlist" :key="proc.code"
                          @click="clickProc(proc)">
                          <span id="icdcode">{{ proc.code }}</span> - <span id="icddesript">{{ proc.description }}</span>
                        </div>
                      </div> ~~>
                      <!~~ <a href="#searchicon"
                        ><img
                          src="https://cdn4.iconfinder.com/data/icons/ionicons/512/icon-ios7-search-512.png"
                          width="20"
                          height="20"
                      /></a> ~~>
                    </div>
                    <div id="icdsectopt" class="col-sm-12 col-md-4 col-lg-3">
                      <label>ICD-10 Description</label>
                      <br />
                      <input
                        required
                        name="icdCode"
                        type="text"
                        id="srchnlookupterms"
                        title="icd-10 diagnosis field"
                        v-model="diagSearchDescrip"
                        :placeholder="
                          icdSearch
                            ? 'Type in your ICD code or a description'
                            : 'Type in your ICD Code'
                        "
                        @keyup.prevent="showDiagSearch"
                      />
                    </div>
                    <div id="icdthirdopt" class="col-sm-12 col-md-4 col-lg-3">
                      <label>Start Date</label><br />
                      <input type="date" id="diagnosisStartDate" name="startDt" />
                    </div>
                    <div id="icdfourthopt" class="col-sm-12 col-md-4 col-lg-3">
                      <label>End Date</label><br />
                      <input type="date" id="diagnosisEndDate" name="endDt" />
                    </div>
                  </div>
                  <div class="icd10fourth col-sm-12 col-lg-12">
                    <div id="icdfirstopt" class="col-sm-12 col-md-4 col-lg-3">
                      <label>Instruction</label>
                      <textarea
                        id="instruction"
                        name="instruction"
                        cols="100"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="icd10thrid col-sm-12 col-lg-12">
                    <ul class="list">
                      <template v-if="activeSearch === 'procedure'">
                        <li
                          v-for="(procedure, index) in paginatedData"
                          :key="index"
                          class="list__item"
                        >
                          <a class="list__link" @click="clickProc(procedure)">
                            {{ index + 1 }}. {{ procedure.description }}
                          </a>
                        </li>
                      </template>
                      <template v-if="activeSearch === 'diagnosis'">
                        <li
                          v-for="(diagnosis, index) in paginatedData"
                          :key="index"
                          class="list__item"
                        >
                          <a class="list__link" @click="clickDiag(diagnosis)">
                            {{ index + 1 }}. {{ diagnosis.description }}
                          </a>
                        </li>
                      </template>
                    </ul>
                    <div v-if="searchedProcs.length > 0">
                      <button
                        :disabled="pageNumber === 0"
                        @click="prevPage"
                        class="btn btn-prev"
                      >
                        Previous
                      </button>

                      <input
                        type="text"
                        v-model="currPageNumber"
                        id="currentPageNumber"
                        style="width: 30px"
                      />
                      <label for="currentPageNumber"
                        >/{{ pageCount() }}
                        <button @click="toPage(currPageNumber - 1)" class="btn ml-2">
                          Go
                        </button></label
                      >

                      <button
                        :disabled="pageNumber >= pageCount() - 1"
                        @click="nextPage"
                        class="btn btn-next"
                      >
                        Next
                      </button>
                    </div>
                    <div v-if="searchedDiags.length > 0">
                      <button
                        :disabled="pageNumber === 0"
                        @click="prevPage"
                        class="btn btn-prev"
                      >
                        Previous
                      </button>

                      <input
                        type="text"
                        v-model="currPageNumber"
                        id="currentPageNumber"
                        style="width: 30px"
                      />
                      <label for="currentPageNumber"
                        >/{{ pageCount() }}
                        <button @click="toPage(currPageNumber - 1)" class="btn ml-2">
                          Go
                        </button></label
                      >

                      <button
                        :disabled="pageNumber >= pageCount() - 1"
                        @click="nextPage"
                        class="btn btn-next"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                  <div class="icd10fifth col-sm-12 col-lg-12">
                    <div id="icdsfrthopt" class="col-sm-12 col-md-12 col-lg-12">
                      <input type="submit" id="savediagnbtn" value="Save" />
                      <input
                        type="button"
                        id="canceldiagbtn"
                        value="Cancel"
                        @click="closeProc"
                      />
                    </div>
                  </div>
                </div>
                <!~~end Order Grid for Modal~~>
              </form>-->
              <div class="order-grid col-sm-12 col-md-12 col-lg-12">
                <div class="columntop" id="diagColumnTop">
                  <!--Start Colum-->
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-6 top-col">
                    <span id="col3" class="coltext">Procedure</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                    <span id="col4" class="coltext">Diagnosis</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                    <span id="col2" class="coltext">Instruction</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                    <span id="col7" class="coltext">Date</span>
                  </div>
                </div>
                <!--end Column top-->
                <template v-if="currentDetails && (currentDetails.code || currentDetails.procedure_code)">
                  <div
                    :key="'diag' + (currentDetails.procId || currentDetails.orddiagid || currentDetails.diagnosis_id || '')"
                    class="columnrow"
                  >
                    <!--start column row-->
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-6 top-row">
                      <span id="row" class="coltext">{{ currentDetails.procedure_code || currentDetails.procShorthand || currentDetails.code || '' }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                      <span id="row" class="coltext">{{ currentDetails.diagnosis_code || currentDetails.diagDescription || '' }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                      <span id="row" class="coltext">{{ currentDetails.instruction || currentDetails.instructions || '' }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                      <span id="row" class="coltext">{{ currentDetails.diagnosis_date || currentDetails.startDate || '' }}</span>
                    </div>
                  </div>
                </template>
                <!--end Column Row-->
              </div>
            </div>
            <!--end Diagnosis Canvas-->
            <!--Signature <Field-->
            <div class="col-sm-12 col-md-12 col-lg-12 sig-wrapper">
              <div class="nursig-wrapper">
                <div class="nursename">
                  <label>Nurse Signature:</label>
                  <input
                    required
                    :disabled="prov && prov.account_type == 'Provider'"
                    class="satisfy-regular"
                    type="text"
                    v-model="finalNureSignature"
                    id="nursename"
                    @input="updateNurseName($event.target.value)"
                   
                  />
                </div>
                <div class="nrssigdate">
                  <label>Signature Date:</label
                  ><input
                    required
                    :disabled="prov && prov.account_type == 'Provider'"
                    type="date"
                    v-model="localOrder.nursedatesig"
                    id="nursdatefld"
                  />
                  <!-- <input :disabled="ordstatus" :class="{ 'disabled-input': ordstatus }"  type="text" id="nrstimstmp" v-model="patient.nurssigtimestamp" /> -->
                </div>
              </div>
              <div class="provsig-wrapper">
                <div class="provname-container">
                  <label>Provider Signature:</label>
                  <input
                    required
                    :disabled="prov && prov.account_type != 'Provider'"
                    class="satisfy-regular"
                    type="text"
                    id="provname"
                    v-model="finalProvSignature"
                    @input="updateProvName($event.target.value)"
                   
                   
                  />
                </div>
                <div class="provsigdate">
                  <label>Signature Date:</label
                  ><input
                    required
                    :disabled="prov && prov.account_type != 'Provider'"
                    type="date"
                    id="provdatefld"
                    v-model="localOrder.providerdatesig"
                  />
                  <!-- <input :disabled="ordstatus" :class="{ 'disabled-input': ordstatus }" type="text" id="provtimstmp" v-model="patient.provsigtimestamp" /> -->
                </div>
              </div>
            </div>
            <!--</Field-->
            <div class="col-sm-12 col-md-12 col-lg-12 ordclosebtn">
              <input
                type="button"
                value="Cancel"
                id="cancelbtn"
                class="cancelbtn"
                @click="cancelOrder"
              />
              <input
                type="submit"
                value="Save & Close"
                id="ordersavebtn"
                class="orderbtn"
              />
            </div>
          </div>
        </form>
      </div>
      <!--endcontainer-->
    </div>
    <!-- </body> -->
  </div>
  </Teleport>
</template>

<script>
import { mapGetters } from "vuex";
import { CURR_API, OTHER_API } from "@/constants/apis";
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
import $ from "jquery";
import { medTimes } from "@/constants/med-times";

export default {
  name: "PendingOrderPopup",
  data() {
    return {
      localOrder: { ...this.order },
      mT: null,
      message: {
        type: String,
        default: () => ({}),
      },
      editorContent: "", //this is going to hold the editors content
      editorInitConfig: {
        height: 300,
        menubar: false,
        plugins: "lists link image preview",
        toolbar:
          "undo redo | bold italic underline | bullist numlist outdent indent | link image",
        setup: (editor) => {
          // Attach TinyMCE event listeners
          editor.on("input", () => {
            this.editorContent = editor.getContent(); // Dynamically update content
            // console.log(this.editorContent);
          });
        },
      }, // Order's message/textfield value
      activeTab: 1, // Switch that focuses on right tab; 0 == order, 1 == medications, 2 == diagnosis, 3 == procedure
      sendtophys: false, // Checkbox for sending order to physician
      woundcare: false, // Checkbox for wound care
      addedItem: false, // True if med/diag/proc added
      finalNureSignature:this.findNurseSignatue(this.prov.account_type),
      finalProvSignature: this.findProviderSignature(this.prov.account_type), //V-model value for Provider signature 
      npiSearch: "", // Primary physician search textfield value
      searchedNpis: null, // List of physicians retrieved via npiSearch
      searchedAddresses: null, // List of addresses associated with chosen physician
      npi: "", // NPI of chosen physician
      npiAddress: "", // Address of chosen physician
      npiPhone: "", // Phone number of chosen physician
      npiFax: "", // Fax number of chosen physician
      npiEmail: "", // Email of chosen physician
      // showMed: false,               // Checkbox that activates Medications tab
      medicationSearchCode: "", // Medication search code value
      medicationSearchDescrip: "", // Medication search description (textfield) value
      searchedMeds: [], // List of medications retrieved via medicationSearch
      allMeds: null, // List of medications already saved for patient

      // showDiag: false,              // Checkbox that activates Diagnosis tab
      savedProviders: [],
      icdSearch: true, // Switch for searching by either icd description (true) or code only (false)
      diagSearchCode: "", // ICD-10 search code value
      diagSearchDescrip: "", // ICD-10 search description (textfield) value
      searchedDiags: [], // List of ICD codes retrieved via icdSearch
      allDiags: null, // List of diagnosis already saved for patient
      //ordstatus:"",                 //order status that's being passed over to the Pendng Order template
      // showProc: false,              // Checkbox that activates Procedure tab
      allProcs: null, // List of procedures already saved for patient
      procSearchDescrip: "", // CPT search descriptions (textfield) value
      searchedProcs: [], // List of CPT codes retrieved via procSearch

      pageNumber: 0,
      size: 5,
      currPageNumber: 1,
      paginatedData: [],
      activeSearch: "",

      manualAllergies: [],
      nursesignature: "", // this.patient.nursesignature,
      nursesigDate: "", //this.patient.nursedatesig,
      providersig: "", //this.patient.providersignature,            //providersig
      providersigDate: "", //this.patient.providerdatesig,    //Provider Signature Date
      orderdate: "", //this.patient.orderdate,
      ordertime: "", //this.patient.ordertime,
      ordertype: "", // this.patient.ordertype,
      ordstatus: false,
      currentDetails: null, // Store medication/procedure details like OrdersPage.vue
    };
  },
  components: {
    editor: Editor,
  },
  props: {
    patient: {
      type: Object,
      default: () => ({}),
    },
    orderNum: {
      type: [String, Number],
      default: () => "",
    },
    order: {
      type: Object,
      default: () => ({}),
    },
    pendingDetails: {
      type: Object,
      default: () => ({}),
    },
    prov: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters("login", {
      user: "getUser",
    }),
  },
  watch: {
    order: {
      handler(newOrder, oldOrder) {
        if (newOrder && Object.keys(newOrder).length > 0) {
          this.localOrder = { ...newOrder };
          if (newOrder.procOrMed === "medication") {
            this.activeTab = 1;
          } else if (newOrder.procOrMed === "procedure") {
            this.activeTab = 3;
          }
          const isNewOrder = !oldOrder || 
            !oldOrder.ordernumber || 
            oldOrder.ordernumber !== newOrder.ordernumber ||
            (oldOrder.orderid && newOrder.orderid && oldOrder.orderid !== newOrder.orderid);
          
          if (isNewOrder) {
            this.$nextTick(() => {
              let pendordwidget = document.getElementById("pendingorder_popup_widget");
              if (pendordwidget) {
                pendordwidget.style.display = "block";
              }
            });
          }
        }
      },
      immediate: true,
      deep: true
    },
    pendingDetails: {
      handler(newDetails, oldDetails) {
        if (newDetails && Object.keys(newDetails).length > 0) {
          this.currentDetails = { ...newDetails };
          this.activeTab =
            this.localOrder.procOrMed === "procedure" ||
            newDetails.code ||
            newDetails.procedure_code
              ? 3
              : 1;
          
          if (oldDetails !== newDetails) {
            this.$nextTick(() => {
              let pendordwidget = document.getElementById("pendingorder_popup_widget");
              if (pendordwidget) {
                pendordwidget.style.display = "block";
              }
            });
          }
        } else {
          this.currentDetails = null;
        }
      },
      immediate: true,
      deep: true
    }
  },
  async mounted() {
    //this.getAllergies();
    //this.loadMedications();
    //this.loadDiagAndProc();
    //this.getSavedProviders();
    /* this.addedItem = false;
    this.npiSearch = this.user.firstName + ' ' + this.user.lastName;
    this.npiAddress = this.user.address;
    this.npiPhone = this.user.phone1;
    this.npiFax = this.user.phone2;*/
    //this.mT = medTimes;

    //this.SetDynamicVariables();
    //
    this.ordstatus = true;

    // Commented out until editing orders for providers is complete
    //  if(this.localOrder.status=="Active" || this.prov.account_type != 'Provider')
    //  {
    //   this.ordstatus =true;
    //  }
    //  else if(this.localOrder.status=="Active-Pending" || this.localOrder.status=="Pending")
    //  {
    //    this.ordstatus =false;
    //  }
    //  // console.log(ordstatus);
  },
  methods: {
    updateProvName(value) {
      if (value != "") {
       
        if(this.prov.account_type=="Provider")
        {
          this.finalProvSignature = value;
        }
         
         //alert(this.localOrder.providersignature);
      } else {
        // this.localOrder.providersignature = "";
         this.finalProvSignature = "";
      }
    },
    findNurseSignatue(obj)
    {
        /*checking account type and then set both signature automatically (Current Logged In User =prov OR use 'ord' to pull in presigned sig)*/
       if(obj=="Registered Nurse")
       {
       
         return this.finalNureSignature = this.prov.user_Fname + ' '+ this.prov.user_Lname;
       }
       if(obj=="Provider" || obj =="Physicians")
       {
        return this.finalNureSignature = this.order.nursesignature;
       }
    },
    findProviderSignature(obj)
    {
      /*checking account type and then set both signature automatically (Current Logged In User =prov OR use 'ord' to pull in presigned sig)*/
      if(obj=="Provider" || obj =="Physicians")
       {
          return this.finalProvSignature = this.prov.user_Fname + ' '+ this.prov.user_Lname;
       }
       if(obj=="Registered Nurse")
       {
        
          return this.finalProvSignature = this.order.providersignature;
       }
    },
    updateNurseName(value) {
      if (value != "") {
        //lets update the provider signature
        //this.localOrder.nursesignature = value;
       
           this.finalNureSignature = value;
          
           console.log("checout order obj");
           console.log(this.order);
        
       
      } else {
       // this.localOrder.nursesignature = "";
        this.finalNureSignature ='';
      }
    },
    updateEmail(value) {
      if (value != "") {
        //lets update the provider signature
        this.localOrder.email = value;
      } else {
        this.localOrder.email = "";
      }
    },
    updateFax(value) {
      if (value != "") {
        //lets update the provider signature
        this.localOrder.fax = value;
      } else {
        this.localOrder.fax = "";
      }
    },
    updateAddress(value) {
      if (value != "") {
        //lets update the provider signature
        this.localOrder.address = value;
      } else {
        this.localOrder.address = "";
      }
    },
    updateNpi(value) {
      if (value != "") {
        //lets update the provider signature
        this.localOrder.npinumber = value;
      } else {
        this.localOrder.npinumber = "";
      }
    },
    updateSecPhys(value) {
      if (value != "") {
        //lets update the provider signature
        this.localOrder.secphysician = value;
      } else {
        this.localOrder.secphysician = "";
      }
    },
    updateDescription(value) {
      alert("H");
      if (value != "") {
        //lets update the provider signature
        this.localOrder.description = value;
      } else {
        this.localOrder.description = "";
      }
    },
    // SetDynamicVariables()
    // {
    //   //on Mount this function will get called and then we'lll set the variables with the Patient Object
    //   alert("Dynamic Variables");
    //   this.message =this.patient.orderdescription;
    // if(this.patient.nursesignature !="")
    // {
    //   this.nursesignature = this.patient.nursesignature;
    //   alert(this.nursesignature);
    // }
    // else{
    //   this.nursesignature= "";
    // }
    // if(this.patient.nursedatesig !="")
    // {
    //   this.nursesigDate=this.patient.nursedatesig;
    // }
    // else{
    //   this.nursesigDate="";
    // }
    // if(this.patient.providersignature !="")
    // {
    //    this.providersig=this.patient.providersignature; //providersig
    //    alert(this.providersig);
    // }
    // else{
    //   this.providersig="";
    // }
    // if(this.patient.providerdatesig !="")
    // {
    //    this.providersigDate=this.patient.providerdatesig;    //Provider Signature Date
    // }
    // else{
    //   this.providersigDate="";
    // }
    // if(this.patient.orderdate !="")
    // {
    //    this.orderdate=this.patient.orderdate;
    // }
    // else{
    //   this.orderdate="";
    // }
    // if(this.patient.ordertime !="")
    // {
    //    this.ordertime= this.patient.ordertime;
    // }
    // else{
    //   this.ordertime="";
    // }
    // if(this.patient.ordertype !="")
    // {
    //   this.ordertype= this.patient.ordertype;
    //   alert(this.ordertype);
    // }
    // else{
    //   this.ordertype="";
    // }
    // // console.log("Mount variables");
    // // console.log(this.nursesignature);

    //   // console.log(this.nursesigDate);
    //   // console.log(this.orderdate);
    //   // console.log(this.patient);
    // },
    pageCount() {
      let l;
      if (this.activeSearch === "procedure") l = this.searchedProcs.length;
      if (this.activeSearch === "diagnosis") l = this.searchedDiags.length;
      return Math.ceil(l / this.size);
    },
    dynamicSignature(patval) {
      if (patval == "") {
        this.nursesignature = "";
      } else {
        this.nursesignature = patval;
      }
    },
    paginateData() {
      let start = this.pageNumber * this.size,
        end = start + this.size;
      if (this.activeSearch === "procedure")
        this.paginatedData = this.searchedProcs.slice(start, end);
      if (this.activeSearch === "diagnosis")
        this.paginatedData = this.searchedDiags.slice(start, end);
    },
    nextPage() {
      this.pageNumber++;
      this.currPageNumber = this.pageNumber + 1;
      this.paginateData();
    },
    prevPage() {
      this.pageNumber--;
      this.currPageNumber = this.pageNumber + 1;
      this.paginateData();
    },
    toPage(pageNumber) {
      this.pageNumber = pageNumber;
      this.paginateData();
    },
    selectNpi(npi) {
      this.npiSearch = npi.name;
      this.npi = npi.npinumber;
      this.searchedNpis = null;
      this.searchedAddresses = npi.addresses;
    },

    selectProv(prov) {
      this.npiSearch = prov.firstname + " " + prov.lastname;
      this.npi = prov.npinumber;
      this.searchedNpis = null;
      this.npiAddress = prov.addr1;
      this.searchedAddresses = null;
      this.npiPhone = prov.tel;
      this.npiFax = prov.fax;
      this.npiEmail = prov.email;
    },

    selectAddr(addr) {
      this.npiAddress = addr.address ? addr.address : "";
      this.npiPhone = addr.tel ? addr.tel : "";
      this.npiFax = addr.fax ? addr.fax : "";
      this.searchedAddresses = null;
    },

    async getAllergies() {
      let content = {
        Allergy: {
          API_Meth: "GetAllergies",
          pid: this.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          let result = res.data.allergies;
          if (result) {
            result.forEach((aller) => {
              this.manualAllergies.push(aller.name);
            });
          }
        });
    },

    async getSavedProviders() {
      let content = {
        Provider: {
          API_Meth: "GetAllProviders",
          patientid: this.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          this.savedProviders = res.data.provider;
        });
    },

    async loadDiagAndProc() {
      let content = {
        Diagnosis: {
          API_Meth: "PopulateDiagGrid",
          patientID: this.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.gridhtml) {
            this.allDiags = res.data.data.filter(
              (diag) => diag.diagnosis_type === "Diagnosis"
            );
            this.allProcs = res.data.data.filter(
              (proc) => proc.diagnosis_type === "Procedure"
            );
          } else {
            this.allDiags = null;
            this.allProcs = null;
          }
        });
    },

    async loadMedications() {
      let content = {
        MedGrid: {
          API_Meth: "PopulateMedGrid",
          pid: this.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.gridhtml) {
            this.allMeds = res.data.data;
          } else {
            this.allMeds = null;
          }
        });
    },

    async saveOrder() {
      let accountType = this.prov.account_type;
      let form = document.getElementById("orderform" + this.patient.pid);
      
      let nursesigname = this.finalNureSignature || $("#nursename").val();
      let nursesigdate = this.localOrder.nursedatesig || document.getElementById("nursdatefld").value;
      let provsigname = this.finalProvSignature || document.getElementById("provname").value;
      let provsigdate = this.localOrder.providerdatesig || document.getElementById("provdatefld").value;
      
      if (!provsigdate && provsigname) {
        const today = new Date();
        provsigdate = today.toISOString().split('T')[0];
      }
      
      let newStatus = "Active"
      
      let medname = "";
      if (this.currentDetails && (this.currentDetails.medName || this.currentDetails.medname)) {
        medname = this.currentDetails.medName || this.currentDetails.medname;
      }
      
      let content = {
        OrderTemp: {
          API_Meth: "UpdateOrder",
          accountnumber: this.patient.accountnumber,
          ordernumber: this.order.ordernumber,
          patientID: this.order.patientid,
          orderdate: this.order.orderdate,
          ordertime: this.order.ordertime,
          ordertype: this.order.ordertype,
          abndelivery: this.order.abndelivery,
          ordReadback: form.elements["phyAgent"].value,
          primphysician: this.order.primary_physician,
          secphysician: this.order.sec_physician,
          email: this.order.email,
          npinumber: this.order.npinumber,
          address: this.order.address,
          phone: this.order.phone,
          fax: this.order.fax,
          sendtophysicans: this.order.sec_physician,
          woundcare: this.order.woundcare,
          verbalorder: this.order.verbalorder,
          verbalStartdt: this.order.orderdate,
          verbalEnddt: "12:00",
          description: this.order.orderdescription,
          status: newStatus,
          hasmed: false,
          hasdiag: false,
          writer: this.user.firstName + " " + this.user.lastName,
          nurseSignature: nursesigname,
          nurseSigDate: nursesigdate,
          provSignature: provsigname,
          provSigDate: provsigdate,
          medname: medname,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.result == "Updated") {
            let msg = "Order number " + (this.order.order_display_number || this.order.ordernumber) + " has been successfully Updated.";
            this.addedItem = false;
            alert(msg);
            this.$emit("childGetAccountPendingOrdersByPatID");
            this.closeOrder();
          } else {
            alert(res.data.data || "Error updating order.");
          }
        })
        .catch((err) => {
          console.error("Error updating order:", err);
          alert("Error updating order. Please try again.");
        });
    },

    async saveMed() {
      let form = document.getElementById("dosesform" + this.patient.pid); //was id
      let content = {
        MedicationInsert: {
          API_Meth: "InsertMedication",
          patientID: this.patient.externId,
          ordernumber: this.orderNum,
          medname: this.medicationSearchDescrip,
          doseamount: form.elements["amount"].value,
          doseUOM: "", //form.elements['UOM'].value,
          frequency: form.elements["freq"].value,
          diagcode: form.elements["reason"].value,
          medRoute: form.elements["route"].value,
          altroute: "",
          instruction: form.elements["instructions"].value,
          medstrtdt: form.elements["startDate"].value
            ? form.elements["startDate"].value
            : null,
          medenddt: form.elements["endDate"].value
            ? form.elements["endDate"].value
            : null,
          changetype: form.elements["neworchange"].value,
          durgclassification: form.elements["drug"].value,
          prn: document.getElementById("prncheckbox" + this.patient.id).checked,
          directionuse: form.elements["understanding"].value,
          additionalsettings: form.elements["settings"].value,
          status: "Pending",
          writer: this.user.firstName + " " + this.user.lastName,
          source: 'Manual', // pending nurse orders are manual entry, not CDA import
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.sqlresult && res.data.sqlresult == "Inserted") {
            this.medicationSearchCode = "";
            this.medicationSearchDescrip = "";
            this.diagSearchCode = "";
            this.diagSearchDescrip = "";
            this.loadMedications();
            alert("Medication successfully added");
            this.addedItem = true;
            document.getElementById("mediationmodal" + this.patient.id).style.display =
              "none";
            $("#mediationmodal" + this.patient.id).css("display", "none");
            // $(".modalbottom form").css("display","none");
            // $(".mednamesec").css("display","none");
            form.reset();
          } else {
            alert(
              "Error with medication insertion. Try again or contact an administrator."
            );
          }
        });
    },

    async saveProc() {
      let form = document.getElementById("procmodal" + this.patient.pid); //was id but pid is in the prop patient object
      let content = {
        Diagnosis: {
          API_Meth: "InsertDiagnosis",
          ordernumber: this.orderNum,
          diagnosis_type: "Procedure",
          onset_exacerbation: "",
          diagnosisDate: form.elements["startDt"].value
            ? form.elements["startDt"].value
            : null,
          endDate: form.elements["endDt"].value ? form.elements["endDt"].value : null,
          diagControlRating: "",
          diagcode: form.elements["icdCode"].value,
          proccode: form.elements["procCode"].value,
          pid: this.patient.externId,
          status: "Pending",
          instruction: form.elements["instruction"].value,
          writer: this.user.firstName + " " + this.user.lastName,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.result && res.data.result == "Inserted") {
            this.diagSearchCode = "";
            this.diagSearchDescrip = "";
            this.procSearchDescrip = "";
            this.loadDiagAndProc();
            this.addedItem = true;
            alert("Procedure successfully added");
            form.style.display = "none";
            form.reset();
          } else {
            alert(
              "Error with procedure insertion. Try again or contact an administrator."
            );
          }
        });
    },

    async saveDiag() {
      let form = document.getElementById("diagnosismodal" + this.patient.pid); //use to be paginateDataid
      let content = {
        Diagnosis: {
          API_Meth: "InsertDiagnosis",
          ordernumber: this.orderNum,
          diagnosis_type: "Diagnosis",
          onset_exacerbation: "",
          diagnosisDate: form.elements["date"].value ? form.elements["date"].value : null,
          endDate: null,
          diagControlRating: form.elements["syscontrol"].value,
          diagcode: form.elements["icdCode"].value,
          proccode: "",
          pid: this.patient.npinumber, //externId,
          status: "Pending",
          instruction: "",
          writer: this.user.firstName + " " + this.user.lastName,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.result && res.data.result == "Inserted") {
            this.diagSearchCode = "";
            this.diagSearchDescrip = "";
            this.loadDiagAndProc();
            this.addedItem = true;
            alert("Diagnosis successfully added");
            form.style.display = "none";
            form.reset();
          } else {
            alert(
              "Error with diagnosis insertion. Try again or contact an administrator."
            );
          }
        });
    },

    async showResults() {
      let content = {
        methname: "GetAllInfo",
        primphysician: this.npiSearch,
      };
      // this.showPreloader()
      await axios
        .post(CURR_API + "/NPILookup.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.results && res.data.results == "No Results Found") {
            this.searchedNpis = null;
          } else this.searchedNpis = res.data;
        });
      // this.stopPreloader()
    },
    async showMedSearch() {
      if (this.medicationSearchDescrip == "") {
        this.searchedMeds = [];
        return;
      }
      let posturl =
        "https://rxnav.nlm.nih.gov/REST/drugs.json?name=" + this.medicationSearchDescrip;
      await axios.get(posturl).then((res) => {
        if (res.data.drugGroup.conceptGroup) {
          for (let tty of res.data.drugGroup.conceptGroup) {
            if (tty.conceptProperties) {
              this.searchedMeds = this.searchedMeds.concat(tty.conceptProperties);
            }
          }
        } else {
          this.searchedMeds = [];
        }
      });
    },
    async showProcSearch() {
      this.activeSearch = "procedure";
      this.searchedProcs = [];
      this.searchedDiags = [];
      this.paginatedData = [];
      if (this.procSearchDescrip == "") {
        this.searchedProcs = [];
        this.searchDiags = [];
        this.paginatedData = [];
        return;
      }
      if (!isNaN(this.procSearchDescrip)) {
        let content = {
          Diagnosis: {
            API_Meth: "SearchProcedure-Code",
            searchterms: this.procSearchDescrip,
          },
        };
        await axios
          .post(CURR_API + "/tswebhook.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            if (res.data.result && res.data.result != "No Data Found") {
              this.searchedProcs = res.data.result;
            } else {
              this.searchedProcs = [];
            }
          });
      } else {
        let content = {
          Diagnosis: {
            API_Meth: "SearchProcedure-Description",
            description: this.procSearchDescrip,
          },
        };
        await axios
          .post(CURR_API + "/tswebhook.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            if (res.data.count) {
              if (res.data.result.msg) {
                alert("Error:" + res.data.result.msg);
              } else {
                this.searchedProcs = res.data.result;
                this.currPageNumber = 1;
                this.pageNumber = 0;
                this.paginateData();
              }
            } else {
              this.searchedProcs = [];
              this.paginatedData = [];
            }
          });
      }
    },
    async showDiagSearch() {
      this.activeSearch = "diagnosis";
      this.searchedProcs = [];
      this.searchedDiags = [];
      this.paginatedData = [];

      if (this.diagSearchDescrip == "") {
        this.searchedProcs = [];
        this.searchedDiags = [];
        this.paginatedData = [];
        return;
      }
      if (this.icdSearch) {
        let content = {
          action: "Search",
          searchTerm: this.diagSearchDescrip,
          ICDCode: "",
          ICDReleaseUrl: "",
        };
        await axios
          .post(CURR_API + "/icd_calls.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            if (res.data.result == 0) {
              this.searchedDiags = [];
            } else {
              this.searchedDiags = res.data.actualResults;
              this.currPageNumber = 1;
              this.pageNumber = 0;
              this.paginateData();
            }
          });
      }
      // else {
      //   let content = {
      //     "action": "CodeLookUp",
      //     "searchTerm": "",
      //     "ICDCode":
      //   }
      // }
    },
    async cancelOrder() {
      this.activeTab = 0;
      if (this.addedItem) {
        if (
          confirm(
            "Are you sure you want to cancel this order? This will delete all procedures, medications, and diagnoses associated with this order after you first opened it."
          )
        ) {
          let content = {
            Order: {
              API_Meth: "ClearPending",
              ordnum: this.orderNum,
              status: "Pending",
            },
          };
          await axios
            .post(CURR_API + "/tswebhook.php", content, {
              headers: { "Content-Type": "application/json;" },
            })
            .then((res) => {
              if (res.data.recRemoved) {
                if (res.data.recRemoved === "Pending Medication and Diagnosis Deleted") {
                  alert("All pending items attached to this order have been deleted.");
                  this.closeOrder();
                } else {
                  alert("Error deleting pending items attached to this order.");
                  this.closeOrder();
                }
              } else {
                alert("Error deleting pending items attached to this order.");
                this.closeOrder();
              }
              this.loadMedications();
              this.loadDiagAndProc();
              this.addedItem = false;
            });
        }
      } else {
        this.closeOrder();
      }
    },
    clickDiag(diag) {
      this.diagSearchCode = diag.code;
      this.diagSearchDescrip = diag.code + " - " + diag.description;
      this.searchedDiags = [];
    },
    clickProc(proc) {
      this.procSearchDescrip = proc.code + " - " + proc.description;
      this.searchedProcs = [];
      this.paginatedData = [];
    },
    clickMed(med) {
      this.medicationSearchCode = med.rxcui;
      this.medicationSearchDescrip = med.name;
      this.searchedMeds = [];
      // $("#medicationName").html(this.medicationSearchCode + ' - ' + this.medicationSearchDescrip)
      // $("#medsearchbox"+this.patient.id).css("display","none");
      // $(".modalbottom form").css("display","flex");
      // $(".mednamesec").css("display","block");
      // $("#cancelbtn"+this.patient.id).css("display", "none")
    },
    showReAddMed(med) {
      this.showAddMed();
      this.medicationSearchDescrip = med.medname;
      this.diagSearchDescrip = med.diagnose_code;
      document.querySelector("#dosesform" + this.patient.pid + " #medRoute").value =
        med.route;
      document.querySelector("#dosesform" + this.patient.pid + " #amount").value =
        med.med_amount;
      document.querySelector("#dosesform" + this.patient.pid + " #medStartdate").value =
        med.med_startdate;
      document.querySelector("#dosesform" + this.patient.pid + " #freqselect").value =
        med.med_frequency;
      document.querySelector(
        "#dosesform" + this.patient.pid + " #medInstructions"
      ).value = med.instruction;
      document.querySelector("#dosesform" + this.patient.pid + " #Medenddate").value =
        med.med_enddate;
    },
    showAddMed() {
      $("#mediationmodal" + this.patient.pid).css("display", "flex");
      // $("#medsearchform"+this.patient.id).css("display", "block")
      // $("#medsearchbox"+this.patient.id).css("display","block");
      // $(".searchresult"+this.patient.id).css("display","block");
      // $("#medsubmitbtn"+this.patient.id).css("display","none");
      // $("#cancelbtn"+this.patient.id).css("display", "block")
      $("#dosesform" + this.patient.pid + " .modalbottom").css("display", "flex");
      // $(".mednamesec").css("display","block");
      $("#dosesform" + this.patient.pid).css("display", "block");
    },
    showAddDiag() {
      $("#diagnosismodal" + this.patient.pid).css("display", "block");
    },
    showReAddProc(proc) {
      this.showAddProc();
      let form = document.getElementById("procmodal" + this.patient.pid);
      this.diagSearchDescrip = proc.diagnosis_code;
      this.procSearchDescrip = proc.procedure_code;
      document.querySelector(
        "#procmodal" + this.patient.pid + " #diagnosisEndDate"
      ).value = proc.end_date;
      document.querySelector(
        "#procmodal" + this.patient.pid + " #diagnosisStartDate"
      ).value = proc.diagnosis_date;
      document.querySelector("#procmodal" + this.patient.pid + " #instruction").value =
        proc.instruction;
    },
    showAddProc() {
      $("#procmodal" + this.patient.pid).css("display", "block");
    },
    closeDiag() {
      let form = document.getElementById("diagnosismodal" + this.patient.pid);
      form.reset();
      form.style.display = "none";
    },
    closeProc() {
      let form = document.getElementById("procmodal" + this.patient.pid);
      form.reset();
      form.style.display = "none";
    },
    closeFirstMed() {
      let modal = document.getElementById("mediationmodal" + this.patient.pid);
      modal.style.display = "none";
      this.medicationSearchCode = "";
      this.medicationSearchDescrip = "";
    },
    closeMed() {
      let doses = document.getElementById("dosesform" + this.patient.pid);
      doses.reset();
      doses.style.display = "none";
      let form = document.getElementById("mediationmodal" + this.patient.pid);
      form.style.display = "none";
      this.medicationSearchCode = "";
      this.medicationSearchDescrip = "";
      this.diagSearchCode = "";
      this.diagSearchDescrip = "";
    },
    closeOrder() {
      /* let order = document.getElementById("pendingorder__popup" + this.patient.id);
order.style.display = "none";
let orderForm = document.getElementById("orderform" + this.patient.id)
orderForm.reset();*/
      this.nursesignature = "";
      this.providersignature = "";
      this.ordertype = "";
      this.currentDetails = null;
      let pndord = document.getElementById("pendingorder_popup" + this.order.patientid);
      if (pndord) {
        pndord.style.display = "none";
      }
      let pendordwidget = document.getElementById("pendingorder_popup_widget");
      if (pendordwidget) {
        pendordwidget.style.display = "none";
      }
      this.$emit("childGetAccountPendingOrdersByPatID");
      //reset patient propl attribues
      // console.log(Object.keys(this.patient).length);
      // for(var i=0; i <=57;i++)
      // {
      //   console.log(this.patient[i]);
      //   this.patient[i]="";
      // }
      // console.log(this.patient);
      // console.log(Object.keys(this.patient).length);
    },
    showPreloader() {
      let preloader = document.getElementById("preloader");
      if (preloader) {
        preloader.style.display = "block";
      }
    },
    stopPreloader() {
      let preloader = document.getElementById("preloader");
      if (preloader) {
        preloader.style.display = "none";
      }
    },
    // defaultTab(show, tab) {
    //   if (!show && this.activeTab == tab) {
    //     this.activeTab = 0
    //   }
    // }
    // medTabView() {

    // },
    // diagTabView() {

    // }
  },
};
</script>

<style scoped lang="scss">
/* @import "/keyon"; */
@import url("https://fonts.googleapis.com/css2?family=Cedarville+Cursive&family=Satisfy&display=swap");

/* Teleported above Pending Orders / Order Lookup (.eh-popup-overlay at
   --eh-popup-z-index 2000000). Below HelpModal (.help-shell at 2000100). */
.msorderwrapper {
  position: fixed;
  z-index: 2000050;
  max-height: 90vh;
  overflow: auto;
}

.satisfy-regular {
  font-family: "Satisfy", serif;
  font-weight: 400;
  font-style: normal;
  font-size: 22px;
}
.list {
  padding: 0;
}

.list__item {
  list-style-type: none;
  /*padding-bottom: 5px;*/
}

/* pagination */
.btn-number {
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-size: 0.75em;
}

.btn-prev,
.btn-next {
  background-color: transparent;

  &:hover {
    background-color: transparent;
  }
}

.list__link {
  font-size: 0.8em;
  color: #0060ff !important;
  cursor: pointer;
  padding: 5px;

  &:hover {
    // text-decoration: underline !important;
    background: #0060ff;
    color: white !important;
  }
}

.selected {
  background: #0060ff;
  color: white !important;
  border-radius: 3px;
}

.allergytext {
  color: red;
}

.ql-editor {
  font-size: 150%;
}
.sig-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
.nursig-wrapper {
  display: flex;
  width: 100%;
  justify-content: left;
}
#nursename {
  margin-right: 15px;
  /*font-family: 'Satisfy-Regular',sans-serif;*/
  font-size: 25px;
}
#provname {
  /*font-family:'Satisfy-Regular',sans-serif;*/
  font-size: 25px;
  font-weight: 600;
}
.sig-wrapper input[type="text"] {
  border-top-style: none;
  border-left-style: none;
  border-right-style: none;
  margin-left: 20px;
  width: 220px;
  background-color: #d3d3d3;
}
.sig-wrapper input[type="date"] {
  width: 220px;
  background-color: #d3d3d3;
  margin-left: 15px;
}
.provsig-wrapper {
  display: flex;
  margin-top: 20px;
}
.nrssigdate {
  margin-left: 15px;
  margin-top: 10px;
}
.disabled-input {
  background-color: #ccc;
}
</style>
